@if ((hideOnboarding$ | async) === false) {
  <app-onboarding></app-onboarding>
} @else {
  <app-nav-bar (toggle)="toggleMenu($event)" [isLoggedIn]="authenticationService.isLoggedIn" [user]="user"
  (openDialog)="openDialogLogin()"></app-nav-bar>
  <app-menu [isMenuOpened]="menuOpened" [isLoggedIn]="authenticationService.isLoggedIn" [user]="user" (toggle)="toggleMenu($event)"
  (openDialog)="openDialogLogin()" (logOut)="logout()"></app-menu>
  <app-desktop-nav-bar [isLoggedIn]="authenticationService.isLoggedIn" (openDialog)="openDialogLogin()"></app-desktop-nav-bar>
  <app-side-bar [isLoggedIn]="authenticationService.isLoggedIn" [user]="user" (openDialog)="openDialogLogin()" (logOut)="logout()"></app-side-bar>
  @if (networkStatus$ | async) {
    <div>
    </div>
  } @else {
    @if (offline) {
      <div class="row offline-div d-flex justify-content-center align-items-center">
        <span>{{'edp.emarket.layout' | translate}}</span>
      </div>
    }
  }
  <router-outlet></router-outlet>
  <app-message-box></app-message-box>
}

